<template>
  <v-container>
    <v-row>
      <v-col>
        <StatField label="Edge" value="edge" icon="mdi-run-fast" color="blue" />
      </v-col>
      <v-col>
        <StatField label="Heart" value="heart" color="red" icon="mdi-heart" />
      </v-col>
      <v-col>
        <StatField label="Iron" value="iron" color="grey darken-2" icon="mdi-dumbbell" />
      </v-col>
      <v-col>
        <StatField label="Shadow" value="shadow" color="black" icon="mdi-ninja" />
      </v-col>
      <v-col>
        <StatField label="Wits" value="wits" color="pink lighten-2" icon="mdi-brain" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import {mapState} from 'vuex';
  import StatField from '@/components/StatField.vue';

  export default {
    name: 'Stats',
    components: {StatField},
    computed: {
      // ...mapState(['characterStats']),
    },

    methods: {},
  };
</script>
